export enum SideBarActionKeys {
    SIDEBAR_UPDATE_DATA = '@@sidebar/UPDATE_DATA',
    SIDEBAR_CHANGE_NAME = '@@sidebar/CHANGE_NAME',
    SIDEBAR_UPDATE_GROUP_SHOWED_ITEMS = '@@sidebar/UPDATE_GROUP_SHOWED_ITEMS',
}
